import { STATE_KEYS } from './state';

const GETTER_TYPES = {
  GET_WORKATO_TOKEN: 'getWorkatoToken',
  GET_WORKATO_TOKEN_REFRESH_FLAG: 'getWorkatoTokenRefreshFlag',
  GET_WORKATO_CONFIG_VALUES: 'getWorkatoConfigValues',
  GET_WORKATO_RECIPE: 'getWorkatoRecipe',
  GET_WORKATO_RECIPE_USER_FOLDER: 'getWorkatoRecipeUserFolder',
  GET_WORKATO_RECIPE_LOAD_STATE: 'getWorkatoRecipeLoadState',
  GET_WORKATO_ADMINS: 'getWorkatoAdmins',
  GET_EXISTING_WORKATO_ACCOUNT: 'getExistingWorkatoAccount',
  GET_EXISTING_WORKATO_USER: 'getExistingWorkatoUser',
  GET_NEW_WORKATO_USER: 'getNewWorkatoUser',
  GET_NEW_WORKATO_ACCOUNT: 'getNewWorkatoAccount',
  GET_DATA_STATE: 'getDataState',
  GET_DO_NOT_SHOW_PRE_BUILD_RECIPES_MODAL: 'getDoNotShowPreBuildRecipeModal',
};

const getters = {
  [GETTER_TYPES.GET_WORKATO_TOKEN](state) {
    return state[STATE_KEYS.WORKATO_TOKEN];
  },
  [GETTER_TYPES.GET_WORKATO_TOKEN_REFRESH_FLAG](state) {
    return state[STATE_KEYS.WORKATO_TOKEN_NEED_TO_REFRESH];
  },
  [GETTER_TYPES.GET_WORKATO_CONFIG_VALUES](state) {
    return state[STATE_KEYS.WORKATO_CONFIG_VALUES];
  },
  [GETTER_TYPES.GET_WORKATO_RECIPE](state) {
    return state[STATE_KEYS.WORKATO_RECIPE];
  },
  [GETTER_TYPES.GET_WORKATO_RECIPE_USER_FOLDER](state) {
    const recipe = state[STATE_KEYS.WORKATO_RECIPE] || {};
    if (recipe.premadeRecipe && recipe.premadeRecipe.length) {
      return recipe.premadeRecipe[0].folder_id || null;
    }
    return null;
  },
  [GETTER_TYPES.GET_WORKATO_RECIPE_LOAD_STATE](state) {
    return state[STATE_KEYS.WORKATO_RECIPE_LOAD_STATE];
  },
  [GETTER_TYPES.GET_WORKATO_ADMINS](state) {
    return state[STATE_KEYS.WORKATO_ADMINS];
  },
  [GETTER_TYPES.GET_EXISTING_WORKATO_ACCOUNT](state) {
    return state[STATE_KEYS.EXISTING_WORKATO_ACCOUNT];
  },
  [GETTER_TYPES.GET_EXISTING_WORKATO_USER](state) {
    return state[STATE_KEYS.EXISTING_WORKATO_USER];
  },
  [GETTER_TYPES.GET_NEW_WORKATO_USER](state) {
    return state[STATE_KEYS.NEW_WORKATO_USER];
  },
  [GETTER_TYPES.GET_NEW_WORKATO_ACCOUNT](state) {
    return state[STATE_KEYS.NEW_WORKATO_ACCOUNT];
  },
  [GETTER_TYPES.GET_DATA_STATE](state) {
    return state[STATE_KEYS.DATA_STATE];
  },
  [GETTER_TYPES.GET_DO_NOT_SHOW_PRE_BUILD_RECIPES_MODAL](state) {
    return state[STATE_KEYS.DO_NOT_SHOW_PRE_BUILD_RECIPES_MODAL].value;
  },
};

export {
  getters,
  GETTER_TYPES,
};
